import { memo } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import RelativeLink from "app/pages/.shared/RelativeLink";
import IconHome from "app/pages/.shared/static/icons/IconHome";
import SvgIconMagnifyingGlassBold from "app/pages/.shared/IconMagnifyingGlassBold";
import IconLightning from "app/pages/.shared/IconLightning";

const AccountAsideMenuFooter = ({ showSmartDPOnRootUrl = false }) => {
	return (
		<>
			{showSmartDPOnRootUrl ? (
				<>
					<li className="sub-nav">
						<RelativeLink
							to={{ pathname: "/listing" }}
							className="sub-nav__main sub-nav__main--link"
						>
							<div className="sub-nav__label">
								<IconLightning
									height={24}
									width={20}
									style={{ marginRight: "20px" }}
								/>
								<FormattedMessage id="sdp.menu.item.flashsales" />
							</div>
						</RelativeLink>
					</li>
					<li className="sub-nav">
						<RelativeLink
							to={{ pathname: "/" }}
							className="sub-nav__main sub-nav__main--link"
						>
							<div className="sub-nav__label">
								<SvgIconMagnifyingGlassBold
									height={29}
									style={{ marginRight: "16px" }}
								/>
								<FormattedMessage id="sdp.menu.item.search.trip" />
							</div>
						</RelativeLink>
					</li>
				</>
			) : (
				<li className="sub-nav">
					<RelativeLink
						to={{ pathname: "/listing" }}
						className="sub-nav__main sub-nav__main--link"
					>
						<div className="sub-nav__label">
							<IconHome height={20} style={{ marginRight: "15px" }} />
							<FormattedMessage id="menu.mobile.all.sales" />
						</div>
					</RelativeLink>
				</li>
			)}
		</>
	);
};

AccountAsideMenuFooter.propTypes = {
	showSmartDPOnRootUrl: PropTypes.bool,
};

export default memo(AccountAsideMenuFooter);
